import React from 'react';
import { Link } from 'react-router-dom';
import { consultants } from '../../data/consultants';
import { industries } from '../../data/industries';
import { firmNav, legalNav } from '../../data/navigation';
import { services } from '../../data/services';
import { Logo } from '../brand/Logo';
import { ButtonLink } from '../ui/ButtonLink';
const linkClass = 'text-sm text-porcelain/65 transition-colors duration-150 hover:text-copper-light';
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="on-dark bg-plum text-porcelain" data-id="element-312" data-mp="3s1vkukfn94a7">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-20" data-id="element-313" data-mp="3n3atlaidduxw">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-12" data-id="element-314" data-mp="3n1hmxv7rbapw">
          <div className="lg:col-span-4" data-id="element-315" data-mp="3j3a2apa69p9f">
            <Link to="/" aria-label="Aurevane Search Partners — home" data-id="element-316" data-mp="3e2w747to69st">
              <Logo tone="light" data-id="element-317" data-mp="3e249yskfc40f" />
            </Link>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-porcelain/65" data-id="element-318" data-mp="3939k56o1hf6t">
              Aurevane Search Partners is an executive search and leadership advisory firm connecting organizations with experienced leaders for C-suite, board, and senior leadership appointments.
            </p>
            <ButtonLink to="/employers#inquiry" size="sm" className="mt-8" data-id="element-319" data-mp="2bcyclh5lsyhd">
              Partner With Us
            </ButtonLink>
          </div>
          <nav aria-labelledby="footer-firm" className="lg:col-span-2" data-id="element-320" data-mp="2gbrh4k2wxf5e">
            <h2 id="footer-firm" className="font-display text-sm font-semibold text-porcelain" data-id="element-321" data-mp="3425bwicvts3o">
              Firm
            </h2>
            <ul className="mt-5 space-y-3" data-id="element-322" data-mp="381w6kx5j4sdh">
              {firmNav.map(l => <li key={l.to} data-id="element-323" data-mp="2u2ef2a0un10f">
                  <Link to={l.to} className={linkClass} data-id="element-324" data-mp="2u5ab1st4zfm8">
                    {l.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
          <nav aria-labelledby="footer-expertise" className="lg:col-span-3" data-id="element-325" data-mp="1img0xrqtdosc">
            <h2 id="footer-expertise" className="font-display text-sm font-semibold text-porcelain" data-id="element-326" data-mp="1nnn7xol4ujxy">
              Expertise
            </h2>
            <ul className="mt-5 space-y-3" data-id="element-327" data-mp="13mkdup9u1a13">
              {services.map(s => <li key={s.slug} data-id="element-328" data-mp="zl8s4uu2x8y6">
                  <Link to={`/expertise#${s.slug}`} className={linkClass} data-id="element-329" data-mp="urw5urcvhe8l">
                    {s.title}
                  </Link>
                </li>)}
            </ul>
          </nav>
          <nav aria-labelledby="footer-industries" className="lg:col-span-3" data-id="element-330" data-mp="ktztjw878d8w">
            <h2 id="footer-industries" className="font-display text-sm font-semibold text-porcelain" data-id="element-331" data-mp="krvlr376iu3c">
              Industries
            </h2>
            <ul className="mt-5 space-y-3" data-id="element-332" data-mp="bul7ra2z8quq">
              {industries.slice(0, 6).map(i => <li key={i.slug} data-id="element-333" data-mp="6vie0lsg6722">
                  <Link to={`/industries#${i.slug}`} className={linkClass} data-id="element-334" data-mp="6wbej50tc0br">
                    {i.name}
                  </Link>
                </li>)}
              <li data-id="element-335" data-mp="219jcv6nzyu25">
                <Link to="/industries" className="text-sm font-semibold text-copper-light hover:text-porcelain" data-id="element-336" data-mp="21914xcrz2ree">
                  All industries
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-14 border-t border-porcelain/10 pt-10" data-id="element-337" data-mp="2dor6cbastolt">
          <h2 className="font-display text-sm font-semibold text-porcelain" data-id="element-338" data-mp="2iic17uh3i2gs">Contact a consultant</h2>
          <ul className="mt-5 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-339" data-mp="2ng3v2u1avynm">
            {consultants.map(c => <li key={c.slug} data-id="element-340" data-mp="1pv9ahoinuw13">
                <Link to={`/consultants/${c.slug}`} className="text-sm font-medium text-porcelain hover:text-copper-light" data-id="element-341" data-mp="1urzqycydntn1">
                  {c.name}
                </Link>
                <a href={`mailto:${c.email}`} className="mt-1 block text-sm text-porcelain/60 [overflow-wrap:anywhere] hover:text-copper-light" data-id="element-342" data-mp="1ztoz9ku7tt7f">
                  {c.email}
                </a>
              </li>)}
          </ul>
        </div>

        <div className="mt-12 flex flex-col gap-6 border-t border-porcelain/10 pt-8 lg:flex-row lg:items-center lg:justify-between" data-id="element-343" data-mp="3f71j3ksq2v2r">
          <p className="text-sm text-porcelain/55" data-id="element-344" data-mp="3dt08n4achwba">© {year} Aurevane Search Partners. All rights reserved.</p>
          <ul className="flex flex-wrap gap-x-6 gap-y-3" data-id="element-345" data-mp="38u778a8c1vrh">
            {legalNav.map(l => <li key={l.to} data-id="element-346" data-mp="3nmqu00b6dqmr">
                <Link to={l.to} className={linkClass} data-id="element-347" data-mp="3iph98xyqe359">
                  {l.label}
                </Link>
              </li>)}
            <li data-id="element-348" data-mp="it3d5vuxbyj">
              <Link to="/cookies#preferences" className={linkClass} data-id="element-349" data-mp="iayjkv4ppf0">
                Cookie Preferences
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>;
}